import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import BarChartIcon from '@mui/icons-material/BarChart';
import MapCard from './MapCard';
import MapCardNoData from './MapCardNoData';

const MAP_NAMES = [
  "de_mirage",
  "de_inferno",
  "de_nuke",
  "de_anubis",
  "de_vertigo",
  "de_ancient",
  "de_cache",
  "de_cobblestone_2018",
  "de_dust_ii",
];

const ProfileStatsTab = ({ mapsStats, hasPlayedAtLeastOneMatch }) => {
  return (
    <Box>
      {/* Performance Overview Section */}
      <Typography
        sx={{
          fontSize: '1.5rem',
          fontWeight: 700,
          color: '#ffffff',
          marginBottom: '1.5rem',
        }}
      >
        Performance by Map
      </Typography>

      {hasPlayedAtLeastOneMatch ? (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
            gap: '1.5rem 3rem',
            width: '100%',
            borderRadius: '10px',
            boxSizing: 'border-box',
            marginBottom: '2rem',
            '@media (max-width: 900px)': {
              gridTemplateColumns: 'repeat(2, 1fr)',
            },
            '@media (max-width: 450px)': {
              gridTemplateColumns: '1fr',
            },
          }}
        >
          {MAP_NAMES.map((name) => (
            <MapCard key={name} name={name} stats={mapsStats} />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {MAP_NAMES.map((name) => (
            <MapCardNoData key={name} name={name} />
          ))}

          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              inset: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.50)',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              borderRadius: '12px',
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '14rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              zIndex: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '3.5px solid #ffffff',
                borderRadius: '50%',
                padding: '0.5rem',
                marginBottom: '0.5rem',
              }}
            >
              <BarChartIcon style={{ width: '3.5rem', height: '3.5rem' }} />
            </Box>
            <Typography
              sx={{
                fontSize: '28px',
                fontWeight: 'bold',
                textAlign: 'center',
                letterSpacing: '1px',
              }}
            >
              No data available
            </Typography>
            <Typography
              sx={{
                fontSize: '16px',
                textAlign: 'center',
              }}
            >
              Start playing to see your stats here!
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

ProfileStatsTab.propTypes = {
  mapsStats: PropTypes.object,
  hasPlayedAtLeastOneMatch: PropTypes.bool.isRequired,
};

export default ProfileStatsTab;
